/**
 * Warm neutrals: #F5F2EB accents on dark UI; muted charcoals / taupe for pale surfaces.
 */
const cream = '#F5F2EB';
const champagne = cream;
/** Hover / muted highlight (warm, not teal) */
const champagneLight = '#CEC8BD';
/** Small caps and heavy type on pale surfaces */
const champagneDark = '#524D46';
/** Expressive accents on pale warm backgrounds (stats, muted labels) */
const mutedAccent = '#7A7468';
const ring = '#A8A29A';

export const theme = {
  breakpoints: {
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    /** Legacy cap; prefer `layout.catalogMaxWidth` for content shells */
    container: '2200px',
  },

  /** Maison-aligned: wide catalog column + symmetric horizontal padding */
  layout: {
    containerPadX: 'clamp(10px, 1.25vw, 28px)',
    catalogWidth: '95%',
    catalogMaxWidth: '2200px',
  },

  /**
   * Fluid type (Maison-style vw + px clamps) for responsive headlines and card metadata.
   */
  type: {
    root: 'clamp(15px, 0.22vw + 14.2px, 19px)',
    body: 'clamp(14px, 0.18vw + 13.5px, 18px)',
    bodySm: 'clamp(12px, 0.14vw + 11.5px, 15px)',
    bodyXs: 'clamp(10px, 0.12vw + 10px, 13px)',
    /** Category nav (maison-style fluid small caps) */
    navCategory:
      'clamp(11px, 0.42vw + 9.2px, 14px)',
    navCategoryLg:
      'clamp(11px, 0.38vw + 9.5px, 15px)',
    megaColHeading:
      'clamp(13px, 0.32vw + 10.5px, 17px)',
    megaLink:
      'clamp(13px, 0.28vw + 11.5px, 18px)',
    megaSpotlightEyebrow:
      'clamp(11px, 0.22vw + 9.5px, 13px)',
    megaSpotlightTitle:
      'clamp(14px, 0.35vw + 12px, 20px)',
    megaSpotlightMeta:
      'clamp(13px, 0.25vw + 11px, 17px)',
    searchInput: 'clamp(14px, 0.22vw + 12.5px, 19px)',
    sectionTitle: 'clamp(1.75rem, 1.8vw + 1.1rem, 3rem)',
    heroDisplay: 'clamp(2.5rem, 4vw + 1.25rem, 5.5rem)',
    productName: 'clamp(13px, 0.22vw + 12px, 17px)',
    price: 'clamp(14px, 0.2vw + 13px, 18px)',
    pageDisplay: 'clamp(2.25rem, 3.2vw + 1rem, 4rem)',
    cardTitle: 'clamp(1.25rem, 1vw + 0.85rem, 2rem)',
  },
  colors: {
    /** Page canvas (body); hero bands use `cream` / explicit fills — keep those unchanged */
    background: '#ffffff',
    foreground: 'hsl(0, 0%, 0%)',
    card: 'hsl(40, 22%, 96%)',
    mutedForeground: 'hsl(0, 0%, 35%)',
    muted: 'hsl(38, 14%, 86%)',
    secondary: 'hsl(38, 12%, 89%)',
    border: 'hsl(35, 12%, 82%)',
    input: 'hsl(35, 12%, 82%)',
    ring,
    noir: 'hsl(0, 0%, 0%)',
    noirSoft: 'hsl(0, 0%, 12%)',
    cream,
    champagne,
    champagneLight,
    champagneDark,
    mutedAccent,
    terracotta: 'hsl(14, 62%, 56%)',
    terracottaLight: 'hsl(16, 70%, 70%)',
    terracottaDark: 'hsl(12, 55%, 42%)',
  },
  gradients: {
    gold: 'linear-gradient(135deg, #E4DFD4 0%, #CEC7BA 52%, #BAB2A6 100%)',
    overlay: 'linear-gradient(180deg, hsla(0, 0%, 0%, 0), hsla(0, 0%, 0%, 0.65))',
    heroAbout: 'linear-gradient(to top, hsl(0, 0%, 0%), transparent)',
    editorialBottom: 'linear-gradient(to top, hsla(0, 0%, 0%, 0.85), hsla(0, 0%, 0%, 0.3), transparent)',
  },
  shadows: {
    luxe: '0 30px 80px -30px hsla(0, 0%, 0%, 0.35)',
    soft: '0 10px 40px -20px hsla(0, 0%, 0%, 0.2)',
    gold: '0 20px 60px -20px hsla(35, 8%, 30%, 0.35)',
  },
  fonts: {
    display: `'Cormorant Garamond', serif`,
    sans: `'Inter', system-ui, sans-serif`,
  },
  easeLuxe: 'cubic-bezier(0.22, 1, 0.36, 1)',
  radius: '0.25rem',
};
